export enum ElementType {
    Carrusel = 1,
    Novedades = 2,
    AccesosDirectos = 3
}